import { Layout } from "@Components/Layout";
import Landing from "@Components/Pages/Landing";
import { ICategory } from "@Interfaces/Api/category";
import { IBannerContent, ICms } from "@Interfaces/Api/cms/Banner";
import { apiCategories } from "@Services/API/IndividualApi's/Category";
import { apiCms } from "@Services/API/IndividualApi's/Cms";
import Head from "next/head";
import { createContext } from "react";
export const BannerContext = createContext<IBannerContent[]>([]);
export const AllRootCategoryContext = createContext<ICategory[]>([]);
export const AllDynamicContext = createContext<ICms[]>([]);
const LandingPage = ({
  allBanners,
  allRootCategories,
  allDynamicContent,
}: {
  allBanners: IBannerContent[];
  allRootCategories: ICategory[];
  allDynamicContent: ICms[];
}) => {
  return (
    <>
      <Head>
        <title>Econut | Act Conscious | Organic &amp; Cold Pressed</title>
        <meta
          name="description"
          content="Our extra virgin coconut oil is best, cold-pressed, pure,natural, raw, unrefined, organic, vegan. Organic &amp; Eco Friendly products.Trusted Brand. Fast Shipping."
        />
        <meta
          name="title"
          content="Econut | Act Conscious | Organic &amp; Cold Pressed"
        />
      </Head>
      <AllRootCategoryContext.Provider value={allRootCategories}>
        <AllDynamicContext.Provider value={allDynamicContent}>
          <Layout>
            <Landing />
          </Layout>
        </AllDynamicContext.Provider>
      </AllRootCategoryContext.Provider>
    </>
  );
};

export async function getStaticProps() {
  let allBanners: IBannerContent[] = [];
  let allDynamicContent: ICms[] = [];
  let allRootCategories: ICategory[] = [];

  try {
    const cmsData = await apiCms.GetDynamicContent();

    // cmsData might already be an array (from response.data.result)
    const cmsArray = Array.isArray((cmsData as any)?.data)
      ? (cmsData as any).data
      : Array.isArray(cmsData)
        ? (cmsData as any)
        : [];

    allDynamicContent = cmsArray;
    allBanners = cmsArray[0]?.banner || [];
  } catch (e) {
    console.error("Error loading CMS data", e);
  }

  const getallRootCategories = async () => {
    try {
      const filterObj = { parent: "/" };
      const queryParam = `&filter=${JSON.stringify(filterObj)}`;
      const response = await apiCategories.getAll!(1, 10, queryParam);

      // Normalize response from handleResponse; always return an array
      if (response instanceof Error) {
        return [];
      }

      const data = (response as any)?.data;

      if (Array.isArray(data)) {
        return data;
      }

      if (Array.isArray(response as any)) {
        return response as any;
      }

      return [];
    } catch (err) {
      console.log(err);
      return [];
    }
  };

  allRootCategories = await getallRootCategories();

  return {
    props: {
      allBanners,
      allRootCategories,
      allDynamicContent,
    },
    revalidate: 30,
  };
}

export default LandingPage;
